import styled from 'styled-components'
import { WidgetInputContainer } from '../../../../search-result-listing/header-section/searchbar/widget-styles'
import { theme } from 'react-components'

export const EventWidgetInputContainer = styled.div`
    z-index: 100;
    height: 100%;
    ${WidgetInputContainer} {
        border-width: ${theme.typography.border.width.xxxThin} 0;
        border-radius: 0 !important;
        height: 100%;
    }
`
